import { render, staticRenderFns } from "./CandidateCommunication.vue?vue&type=template&id=144256f1&scoped=true"
import script from "./CandidateCommunication.vue?vue&type=script&lang=js"
export * from "./CandidateCommunication.vue?vue&type=script&lang=js"
import style0 from "./CandidateCommunication.vue?vue&type=style&index=0&id=144256f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144256f1",
  null
  
)

export default component.exports